var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseRemoteService } from "../core/BaseRemoteService";
export class ResourceTagsService extends BaseRemoteService {
    post(id, tagIds) {
        const _super = Object.create(null, {
            postRequest: { get: () => super.postRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const model = { resourceType: "cwm", tagIds };
            const url = `${this.apiRoot}/resourcetags/${id}`;
            return yield _super.postRequest.call(this, url, model);
        });
    }
    get(id) {
        const _super = Object.create(null, {
            getRequest: { get: () => super.getRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/resourcetags/${id}?pageSize=9999`;
            const response = yield _super.getRequest.call(this, url);
            return response.data && response.data.map((item) => item.tagId);
        });
    }
}
